<script>
  /* global Global, DEV_ENV */
  import Header from '../../common/Header.svelte';
  import Footer from '../../common/Footer.svelte';
  import Title from '../../common/Title.svelte';
  import Input from '../../common/Input.svelte';
  import FileDragAndDrop from '../../common/FileDragAndDrop.svelte';
  import Button from '../../common/Button.svelte';
  import MessageBox from '../../common/MessageBox.svelte';
  import Common from '../../js/common.js';
  import Validation from '../../js/validation.js';
  import ALL_FILE_FIELDS from '../../js/fields/allFileFields.js';

  let lang;

  let user = JSON.parse(window.localStorage.getItem('user'));
  if (DEV_ENV) user = { firstName: 'Jan', lastName: 'Novák', roles: ['ROLE_ADMIN'] };
  if (!user.roles.includes('ROLE_ADMIN')) window.location.href = window.localStorage.getItem('previousPage') || './';

  let value;
  let file;

  value = {
    path: undefined,
  };

  if (!DEV_ENV) {
    (async () => {
      // eslint-disable-next-line no-undef
      const response = await fetch(`${Common.BACKEND_URL}/user/logged`);

      if (response.ok) {
        const data = await response.json();

        user = data;
        window.localStorage.setItem('user', JSON.stringify(data));
      } else {
        user = undefined;
        window.localStorage.removeItem('user');

        back();
      }
    })();
  }

  let messageBox;
  let display = 'button';
  let errors = [];

  function uploadImage (validate = true) {
    display = 'loading';
    errors = [];

    messageBox = {
      cs: { color: 'blue', message: i18n.uploadInProgress.cs },
      en: { color: 'blue', message: i18n.uploadInProgress.en },
    };

    try {
      // eslint-disable-next-line no-undef
      const formData = new FormData();

      const data = Validation.convertAndCheck(ALL_FILE_FIELDS, validate, value);

      formData.append('data', JSON.stringify(data));
      if (file) formData.append('file', file);

      (async () => {
        // eslint-disable-next-line no-undef
        const response = await fetch(`${Common.BACKEND_URL}/admin/upload/image`, {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          messageBox = {
            cs: { color: 'green', message: 'Obrázek byl úspěšně nahrán.' },
            en: { color: 'green', message: 'Image has been successfully uploaded.' },
          };

          display = 'saved';
        } else {
          messageBox = {
            cs: { color: 'red', message: i18n.unexpectedError.cs },
            en: { color: 'red', message: i18n.unexpectedError.en },
          };

          display = 'error';
        }
      })();
    } catch (error) {
      errors = error.errors;

      messageBox = {
        cs: { color: 'red', errors: errors.map(error => error.message.cs) },
        en: { color: 'red', errors: errors.map(error => error.message.en) },
      };

      display = 'error';
    }
  }

  function back () {
    window.location.href = window.localStorage.getItem('previousPage') || './';
  }

  const i18n = {
    pageTitle: {
      cs: `Admin | ${Global.project.name.cs}`,
      en: `Admin | ${Global.project.name.en}`,
    },
    path: {
      cs: 'Cesta',
      en: 'Path',
    },
    uploadImage: {
      cs: 'Nahrát obrázek',
      en: 'Upload image',
    },
    back: {
      cs: 'Zpět',
      en: 'Back',
    },
    uploadInProgress: {
      cs: 'Probíhá nahrávání obrázku...',
      en: 'Image upload in progress...',
    },
    unexpectedError: {
      cs: '(Ne)očekávaná chyba. `E29`',
      en: '(Un)expected error. `E29`',
    },
    withoutValidation: {
      cs: 'bez validace',
      en: 'without validation',
    },
    onlyForAdministrators: {
      cs: 'Tato stránka je pouze pro administrátory. Pokud nejste administrátor, prosím opusťte tuto stránku.',
      en: 'This page is only for administrators. If you are not an administrator, please leave this page.',
    },
  };
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='admin/upload/image' bind:lang bind:user/>

<Title/>

<div class='admin-upload-image'>
  <div class='admin-upload-image-box'>
    <MessageBox value={{ color: 'yellow', message: i18n.onlyForAdministrators[lang] }} textAlign='center'/>

    <!-- PATH -->
    <Input bind:value={value.path} label={i18n.path[lang]} prepend='/img/'
      error={errors.find(error => error.fieldName === 'path')?.message[lang]}
      disabled={['loading', 'saved'].includes(display)}/>

    <!-- FILE -->
    <FileDragAndDrop bind:value={file} bind:lang disabled={['loading', 'saved'].includes(display)}/>

    {#if display === 'loading' || display === 'error'}
      <div class='admin-upload-image-box-message-box'>
        <MessageBox value={messageBox ? messageBox[lang] : undefined}/>
      </div>
    {/if}

    {#if display === 'button' || display === 'error'}
      <div class='admin-upload-image-box-button'>
        <Button value={i18n.uploadImage[lang]}
          onClick={() => { uploadImage(); }} icon='upload' color='green'/>
      </div>
    {/if}

    {#if display === 'saved'}
      <div class='admin-upload-image-box-message-box-and-button'>
        <div class='admin-upload-image-box-message-box-and-button-message-box'>
          <MessageBox value={messageBox ? messageBox[lang] : undefined}/>
        </div>

        <div class='admin-upload-image-box-message-box-and-button-button'>
          <Button value={i18n.back[lang]} onClick={back} icon='arrow_back'
            cssClass='admin-upload-image-box-message-box-and-button-button-component'/>
        </div>
      </div>
    {/if}
  </div>

  <div class='admin-upload-image-right-panel'>
    <div class='admin-upload-image-right-panel-box'/>

    <div class='admin-upload-image-right-panel-save-without-validation'>
      <Button value={i18n.uploadImage[lang] + ' ' + i18n.withoutValidation[lang]}
        onClick={() => { uploadImage(false); }} icon='warning'/>
    </div>
  </div>
</div>

<Footer bind:lang/>

<style>
  .admin-upload-image {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    max-width: 1440px;

    padding: 40px 60px;

    margin: auto;
  }

  .admin-upload-image-box {
    display: flex;
    flex-direction: column;
    gap: 40px;

    width: calc((100% - 40px) / 3 * 2);
  }

  .admin-upload-image-box-button {
    display: flex;
  }

  .admin-upload-image-box-message-box-and-button {
    display: flex;
    gap: 40px;
  }

  .admin-upload-image-box-message-box-and-button-message-box {
    width: calc((100% - 40px) / 3 * 2);
  }

  .admin-upload-image-box-message-box-and-button-button {
    width: calc((100% - 40px) / 3);
  }

  .admin-upload-image-right-panel {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;
    gap: 40px;

    width: calc((100% - 40px) / 3);
  }

  .admin-upload-image-right-panel-box {
    height: 100%;

    padding: 20px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);
  }

  :global(.admin-upload-image-box-message-box-and-button-button-component) {
    height: 100% !important;
  }

  :global(body.dark) .admin-upload-image-right-panel-box {
    background: var(--grey-8);
  }

  @media only screen and (max-width: 1300px) {
    .admin-upload-image-box {
      width: 100%;
    }

    .admin-upload-image-right-panel {
      display: none;
    }
  }

  @media only screen and (max-width: 900px) {
    .admin-upload-image {
      padding: 40px;
    }

    .admin-upload-image-box-message-box-and-button {
      flex-direction: column;
      gap: 20px;
    }

    .admin-upload-image-box-message-box-and-button-message-box, .admin-upload-image-box-message-box-and-button-button {
      width: 100%;
    }

    :global(.admin-upload-image-box-message-box-and-button-button-component) {
      height: 40px !important;
    }
  }

  @media only screen and (max-width: 350px) {
    .admin-upload-image {
      padding: 40px 20px;
    }
  }
</style>
